/* eslint-disable array-callback-return */
import React, { useEffect, useState } from "react";
import "./PositionList.scss";
import axios from "axios";
import Filters from "../components/Filters";

const PostGrid = () => {
  const [axiosData, setAxiosData] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState("region-all");

  const [subscribeForm, setSubscribeForm] = useState({
    name: "",
    email: "",
  });

  const handleSubmit = async () => {
    const { name, email } = subscribeForm;
    if (name.length === 0 || email.length === 0) {
      alert("Please fill in all fields");
      return;
    }

    alert("Thank you for subscribing!");

    await axios.post(
      "https://api.togetherwecandosomuchmore.nl/hellodialog",
      {
        email: email,
        voornaam: name ? name.split(" ")[0] : "",
        achternaam: name.split(" ")[1] ? name.split(" ")[1] : "",
        _state: "Contact",
        groups: [2],
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    setSubscribeForm({ name: "", email: "" });
  };

  const sendHeightToParent = () => {
    const iframe = window.frameElement; // Get reference to the iframe element
    const contentDocument = iframe.contentDocument; // Access the content document

    if (contentDocument) {
      // Use the content document's body or another element to calculate height
      const contentHeight = contentDocument.body.scrollHeight;

      // Send the height to the parent
      window.parent.postMessage(
        { type: "resizeIframe", height: contentHeight },
        "*"
      );
    }
  };

  useEffect(() => {
    sendHeightToParent();
  }, []);

  useEffect(() => {
    sendHeightToParent();
  }, [selectedFilter]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://sheets.googleapis.com/v4/spreadsheets/1NMNX7gdJp2_zf7jcFRm3j2KohKMLOmoww4JVoOq7Kow/values/2:30?key=AIzaSyDw5asg8ciaDk7CWwxQHBuKD3DzKSHRZfE"
      );
      setAxiosData(response.data);
    };

    fetchData();
  }, []);

  const allRegions = axiosData?.values.map((c) => c[0]);
  const uniqueRegions = [...new Set(allRegions)];
  const allRoutes = axiosData?.values.map((c) => c[2]);
  const uniqueRoutes = [...new Set(allRoutes)];

  const createRoute = (routeName, index) => {
    const routeNameArray = routeName.toUpperCase().split("-");
    const routeNameDisplay = routeNameArray.join(" - ");

    // Filtered items based on the selected region
    const filteredItems = axiosData?.values.filter(
      (item) =>
        (selectedFilter === "region-all" ||
          item[0].toLowerCase().includes(selectedFilter.slice(7))) &&
        item[2].startsWith(routeName)
    );

    // If there are no filtered items, return null
    if (filteredItems.length === 0) {
      return null;
    }

    return (
      <>
        <div className="position-region" key={index}>
          <h5 className="region-header">
            {routeNameDisplay}
            <br />
          </h5>
          <table>
            <tbody>
              <tr className="first-row-table">
                <td>Vessel</td>
                <td>Region</td>
                <td>Voy</td>
                <td>{routeName.split("-")[0]}</td>
                <td>{routeName.split("-")[1]}</td>
                <td>{routeName.split("-")[2]}</td>
                {routeName.split("-")[3] ? (
                  <td>{routeName.split("-")[3]}</td>
                ) : null}
                {routeName.split("-")[4] ? (
                  <td>{routeName.split("-")[4]}</td>
                ) : null}
                {routeName.split("-")[5] ? (
                  <td>{routeName.split("-")[5]}</td>
                ) : null}
                {routeName.split("-")[6] ? (
                  <td>{routeName.split("-")[5]}</td>
                ) : null}

                <td></td>
              </tr>
              {axiosData?.values.map((item, index) => {
                if (
                  (selectedFilter === "region-all" ||
                    item[0].toLowerCase().includes(selectedFilter.slice(7))) &&
                  item[2].startsWith(routeName)
                ) {
                  return (
                    <tr key={index}>
                      <td>
                        <span className="mobile-only">
                          Vessel <br />
                        </span>
                        {item[1]}
                      </td>
                      <td>
                        <span className="mobile-only">
                          Region <br />
                        </span>
                        {item[5]}
                      </td>
                      <td>
                        {" "}
                        <span className="mobile-only">
                          Voy <br />
                        </span>
                        {item[3]}
                      </td>

                      <td>
                        <span className="mobile-only">
                          {item[2].split("-")[0]} <br />
                        </span>

                        {item[4].split("|")[0]}
                      </td>
                      <td>
                        <span className="mobile-only">
                          {item[2].split("-")[1]} <br />
                        </span>
                        {item[4].split("|")[1]}
                      </td>
                      <td>
                        <span className="mobile-only">
                          {item[2].split("-")[2]} <br />
                        </span>
                        {item[4].split("|")[2]}
                      </td>
                      <td>
                        <span className="mobile-only">
                          {item[2].split("-")[3]} <br />
                        </span>
                        {item[4].split("|")[3]}
                      </td>
                      {item[4].split("|")[4] ? (
                        <td>
                          <span className="mobile-only">
                            {item[2].split("-")[4]} <br />
                          </span>
                          {item[4].split("|")[4]}
                        </td>
                      ) : null}
                      {item[4].split("|")[5] ? (
                        <td>
                          <span className="mobile-only">
                            {item[2].split("-")[5]} <br />
                          </span>
                          {item[4].split("|")[5]}
                        </td>
                      ) : null}

                      <td>
                        <a
                          className="get-quote-btn"
                          href={`mailto:sales@mannlines.nl?subject=Quote%20request%20for%20${item[1]}%20[Region: ${item[0]}]&body=Dear,%0A%0ABefore%20sending%20this%20email,%20please%20answer%20all%20questions%20below%20(if%20possible).%20With%20your%20input,%20we%20can%20quote%20you%20as%20soon%20as%20possible.%0A%0A1.%20What%20is%20the%20loading%20and%20discharge%20location%3F%0A2.%20What%20is%20the%20total%20amount%20of%20freight%20tonnes%3F%0A3.%20What%20is%20the%20weight%20of%20your%20heaviest%20piece%20(in%20metric%20tonnes)%3F%0A4.%20Describe%20your%20cargo%20(please%20provide%20keywords)%0A%0AThank%20you%20for%20your%20cooperation.%0A%0ABest%20regards,
`}
                        >
                          GET QUOTE
                        </a>
                      </td>
                    </tr>
                  );
                }
              })}
            </tbody>
          </table>
        </div>
      </>
    );
  };

  return (
    <div className="position-list">
      <Filters regions={uniqueRegions} onFilterChange={setSelectedFilter} />

      {uniqueRoutes?.map((reg, index) => createRoute(reg, index))}

      <div className="subscribe-schedule">
        <div className="inner-left">
          <strong>STAY UP-TO DATE</strong>
          <span className="divider"></span>
          <p>
            SUBSCRIBE TO <br />
            OUR <strong>SCHEDULE</strong>
          </p>
        </div>
        <div className="inner-right">
          <div className="form-field">
            <label htmlFor="name">What is your name?</label>
            <input
              type="text"
              id="name"
              name="name"
              placeholder="Your name"
              value={subscribeForm.name}
              onChange={(e) => {
                setSubscribeForm({ ...subscribeForm, name: e.target.value });
              }}
            />
          </div>
          <div className="form-field">
            <label htmlFor="email">What is your email?</label>

            <input
              type="email"
              id="email"
              name="email"
              placeholder="Your email address"
              value={subscribeForm.email}
              onChange={(e) => {
                setSubscribeForm({ ...subscribeForm, email: e.target.value });
              }}
            />
          </div>
          <div className="form-field">
            <label className="disable-mobile" style={{ visibility: "hidden" }}>
              Subscribe
            </label>
            <button
              onClick={() => {
                handleSubmit();
              }}
            >
              Subscribe
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PostGrid;
